import { render } from "./FavoritesPage.vue?vue&type=template&id=1c695584&scoped=true"
import script from "./FavoritesPage.vue?vue&type=script&lang=js"
export * from "./FavoritesPage.vue?vue&type=script&lang=js"

import "./FavoritesPage.vue?vue&type=style&index=0&id=1c695584&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c695584"]])

export default __exports__